module.exports = __webpack_public_path__ + "static/media/interactive-pic-book-preview-03.14942a0e.jpg";